module.exports = __webpack_public_path__ + "static/media/door.0b930085.svg";